import React, { createContext, useState, useEffect } from 'react';
import {
  getUser,
  loginToBasejump
} from '../providers/BasejumpApiProvider';
import { safeGtagEvent } from './AnalyticsProvider';
import { IS_STANDALONE } from '../constants';

const DISCORD_API_URL = 'https://discord.com/api/v10';
export const AuthContext = createContext();

const getUserFromDiscord = async (token) => {
  const data = await fetch(`${DISCORD_API_URL}/users/@me`, {
    headers: {
      'Authorization': `Bearer ${token}`
    }
  });
  if (!data.ok) {
    return null;
  }
  return await data.json();
};

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [basejumpToken, setBasejumpToken] = useState(null);

  useEffect(() => {
    (async () => {
      const storedToken = localStorage.getItem('discordToken');
      if (storedToken) {
        try {
          const loginData = await loginToBasejump(storedToken);
          const { user, access_token } = loginData;
          if (user) {
            setUser(user);
            setBasejumpToken(access_token);
            safeGtagEvent("user_login", user);
          } else {
            throw new Error('Failed to get access token')
          }
        } catch (err) {
          localStorage.removeItem('discordToken');
        }
      }
    })();
  }, []);

  const login = async (token) => {
    const loginData = await loginToBasejump(token);
    const { user, access_token } = loginData;
    if (user) {
      localStorage.setItem('discordToken', token);
      setUser(user);
      setBasejumpToken(access_token);
      safeGtagEvent("user_login", user);
    }
  };

  const logout = () => {
    localStorage.removeItem("discordToken");
    setUser(null);
    setBasejumpToken(null);
  };

  const isAuthenticated = () => {
    return !!user;
  };

  const reloadUser = async () => {
    if (basejumpToken) {
      try {
        const userData = await getUser(basejumpToken);
        setUser(userData)
      } catch (err) {
        console.error(err);
      }
    }
  }

  const value = {
    user,
    login,
    logout,
    setUser,
    reloadUser,
    basejumpToken,
    isAuthenticated,
  };

  return (
    <AuthContext.Provider value={value}>
      {children}
    </AuthContext.Provider>
  );
};
